import moment from 'moment';

// Translate dates depending on locale to show day and month
const formatDatesToLocale = () => {
  const currentLocale = moment.locale(); // read current locale
  if (currentLocale) {
    switch (currentLocale) {
      case 'en':
        return 'Do MMMM';
      case 'es':
        return 'D MMMM';
      default:
        return 'D MMMM';
    }
  }
  return 'D MMMM';
};

export const VERIFICATION_DATE_FORMAT = 'DD MMM YYYY';

/**
 * A momentjs format wrapper
 * if we ever need to migrate off from momentjs, we can reuse this
 * @param {Object} date a string, Date or moment date
 * @param {String} format
 * @param {String} locale
 * @return {String} date formatted as string
 */
export const formatDate = (date, format, locale = moment.locale()) =>
  moment(date).locale(locale).format(format);

export default formatDatesToLocale;
